import type * as React from 'react';
import { AttentionList, EmptyState, KpiCard, OverviewLayout, TodayLayout } from '@redhand/ui';
import { demoAttention, demoTasks } from '../demo-data.js';
import { PageIntro, StateSection } from '../ui-helpers.js';

const severityLabels = { info: 'Info', warning: 'Pozor', critical: 'Kritické' } as const;

export function LayoutsPage(): React.JSX.Element {
  return (
    <div>
      <PageIntro
        title="Vstupní layouty: Dnešek a Přehled"
        lead="Dva archetypy vstupní obrazovky — úkolový TodayLayout (obrazovka = úkol, ne tabulka) a číselný OverviewLayout. Produkt si volí; plné ukázky jsou ve Vzorových obrazovkách."
      />
      <StateSection title="TodayLayout (miniatura)">
        <div className="rh-card" style={{ background: 'var(--rh-canvas)' }}>
          <TodayLayout
            title="Dnešek"
            date="pátek 29. srpna 2026"
            attention={
              <div className="rh-card">
                <AttentionList ariaLabel="Co hoří" severityLabels={severityLabels} items={demoAttention.slice(0, 1)} />
              </div>
            }
            aside={<div className="rh-card">Dnešní schůzky: 2</div>}
          >
            <div className="rh-card">
              <ul style={{ margin: 0, paddingLeft: 20 }}>
                {demoTasks.slice(0, 2).map((t) => (
                  <li key={t.id}>
                    {t.title} — {t.due}
                  </li>
                ))}
              </ul>
            </div>
          </TodayLayout>
        </div>
      </StateSection>
      <StateSection title="OverviewLayout (miniatura)">
        <div className="rh-card" style={{ background: 'var(--rh-canvas)' }}>
          <OverviewLayout
            title="Přehled"
            periodPicker={<button type="button" className="rh-btn">Posledních 30 dnů</button>}
            kpis={
              <>
                <KpiCard label="Tržby" value="145 500 Kč" delta={{ value: '12 %', direction: 'up', srLabel: 'nárůst o 12 procent' }} />
                <KpiCard label="Objednávky" value="436" />
              </>
            }
            charts={<div className="rh-card">graf</div>}
            aside={<div className="rh-card">donut</div>}
          />
        </div>
      </StateSection>
      <StateSection title="Prázdný Dnešek" description="I první den bez úkolů má co říct.">
        <div className="rh-card" style={{ background: 'var(--rh-canvas)' }}>
          <TodayLayout title="Dnešek" date="pátek 29. srpna 2026">
            <div className="rh-card">
              <EmptyState
                icon={<span>☀️</span>}
                title="Dnes nemáš žádné úkoly"
                description="Až přijde poptávka nebo se posune případ, objeví se tady jako úkol s termínem."
              />
            </div>
          </TodayLayout>
        </div>
      </StateSection>
    </div>
  );
}
